import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useAuth } from '@/App';
import Navbar from '@/components/Navbar';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Lightbulb, Loader2, Sparkles } from 'lucide-react';
import axios from 'axios';

const Recommendations = () => {
  const { API } = useAuth();
  const [recommendation, setRecommendation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRecommendations();
  }, []);

  const fetchRecommendations = async () => {
    try {
      const response = await axios.get(`${API}/recommendations`);
      setRecommendation(response.data);
    } catch (error) {
      console.error('Error fetching recommendations:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F5F0]">
      <Navbar />

      <div className="container mx-auto px-4 md:px-6 lg:px-12 py-6 md:py-8 max-w-7xl" data-testid="recommendations-page">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div className="mb-6 md:mb-8">
            <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl font-light text-[#1A4D2E] mb-2">
              Recomandări Personalizate
            </h1>
            <p className="text-base md:text-lg text-[#4a5568]">
              Sfaturi personalizate bazate pe datele tale de sănătate
            </p>
          </div>

          {loading ? (
            <div className="flex items-center justify-center py-20">
              <Loader2 className="w-12 h-12 text-[#1A4D2E] animate-spin" />
            </div>
          ) : recommendation ? (
            <Card className="border-none card-shadow">
              <CardHeader className="pb-4">
                <div className="flex items-center justify-between flex-wrap gap-3">
                  <CardTitle className="font-serif text-xl md:text-2xl text-[#1A4D2E] flex items-center">
                    {recommendation.type === 'ai_generated' ? (
                      <>
                        <Sparkles className="w-5 h-5 md:w-6 md:h-6 mr-2 flex-shrink-0" />
                        <span>Recomandări AI</span>
                      </>
                    ) : (
                      <>
                        <Lightbulb className="w-5 h-5 md:w-6 md:h-6 mr-2 flex-shrink-0" />
                        <span>Recomandări</span>
                      </>
                    )}
                  </CardTitle>
                  <CardDescription className="text-sm md:text-base">
                    {new Date(recommendation.created_at).toLocaleDateString('ro-RO', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </CardDescription>
                </div>
              </CardHeader>
              <CardContent>
                <div className="bg-[#F5F5F0] p-4 md:p-6 rounded-xl">
                  <div className="prose prose-slate max-w-none">
                    <p className="text-sm md:text-base text-[#4a5568] whitespace-pre-wrap leading-relaxed">
                      {recommendation.content}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ) : (
            <Card className="border-none card-shadow">
              <CardContent className="text-center py-12 md:py-16">
                <Lightbulb className="w-16 h-16 md:w-20 md:h-20 text-[#E2E8F0] mx-auto mb-4" />
                <h3 className="font-serif text-xl md:text-2xl text-[#1A4D2E] mb-2">
                  Nu există recomandări disponibile
                </h3>
                <p className="text-sm md:text-base text-[#4a5568]">
                  Completează profilul și adaugă metrici de sănătate pentru recomandări personalizate
                </p>
              </CardContent>
            </Card>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default Recommendations;